/**
 * Wraps a fill in the blank prompt in a full question form component
 * Used for a question's assessment view / preview
 */

import React from 'react';
import PropTypes from 'prop-types';
import AssessmentQuestionForm from '../AssessmentQuestionForm';
import Prompt from './Prompt';

export default function FillInTheBlankQuestion(props) {
  return (
    <AssessmentQuestionForm
      {...props}
      hasMultipartAnswer
      questionType="FillInTheBlank"
      stimulusPosition={props.stimulusPosition}
    >
      <Prompt
        locale={props.locale}
        questionBody={props.questionBody}
        questionId={props.questionId}
        questionTTSEnabled={props.questionTTSEnabled}
        randomizeChoices={props.randomizeChoices}
        randomizeSeed={props.randomizeSeed}
        savedResult={props.savedResult}
        usePromptStyle={!props.useSubmitButton}
      />
    </AssessmentQuestionForm>
  );
}

FillInTheBlankQuestion.propTypes = {
  disabled: PropTypes.bool,
  // AIDEV-NOTE: isInReadingGame is not used directly — it's passed through to AssessmentQuestionForm via {...props}
  isInReadingGame: PropTypes.bool,
  isInSlide: PropTypes.bool,
  locale: PropTypes.oneOf(['en', 'EN', 'es', 'ES']).isRequired,
  questionBody: PropTypes.string.isRequired,
  questionId: PropTypes.number.isRequired,
  questionTTSEnabled: PropTypes.bool,
  randomizeChoices: PropTypes.bool,
  saveDebounce: PropTypes.number,
  savedResult: PropTypes.object,
  stimulusPosition: PropTypes.string,
  useSubmitButton: PropTypes.bool,
};

FillInTheBlankQuestion.defaultProps = {
  disabled: false,
  isInReadingGame: false,
  isInSlide: false,
  questionTTSEnabled: true,
  randomizeChoices: false,
  saveDebounce: 300,
  savedResult: {},
  stimulusPosition: 'below',
  useSubmitButton: false,
};
